
(function ($) {
    $(document).ready(function () {

        if ($('#list_of_members').length > 0) {

            const api_url = location.protocol + "//" + location.host + '/amas-api/externaldata/getdata'; 
            const ext_url = $('#list_of_members').attr('url');
            var exData = JSON.stringify({ 'external_url': ext_url });

            $.ajax({
                type: 'POST',
                contentType: 'application/json', //is the type of data you're sending
                //dataType: 'html',  //The type of data expected from the server
                data: exData, 
                url: api_url,
                crossDomain: true,
                success: function (result) {
                    $("#list_of_members").html(result);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    console.error('jqXHR: ' + jqXHR + '\ntextStatus: ' + textStatus + '\nerrorThrown: ' + errorThrown);
                    $("#list_of_members").text("Could not load data. Please contact support");
                }
            }
            );
        }
    });
}(jQuery));  